import { BaseModel } from "./BaseModel";

export interface IGenericBaseModel {
  uuid?: string;
  dateCreated?: string;
  dateModified?: string;
  isDeleted?: boolean;
  isActive?: boolean;
}

export class GenericBaseModel extends BaseModel {
  uuid?: string;
  key?: React.Key;
  dateCreated?: string;
  dateModified?: string;
  isDeleted?: boolean;
  isActive?: boolean;

  constructor(data: IGenericBaseModel) {
    super(data);
    this.key = data.uuid;
    this.uuid = data.uuid;
    this.dateCreated = data.dateCreated;
    this.dateModified = data.dateModified;
    this.isDeleted = data.isDeleted;
    this.isActive = data.isActive;
  }
}